var _circle, _rect, _path, _rect2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandleBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F9F8F8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 23.9375,
    y: 15.5,
    width: 1.07812,
    height: 1,
    fill: "#F84F39"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.805 11.9948C19.5316 11.7214 19.5316 11.2782 19.805 11.0048C20.0784 10.7315 20.5216 10.7315 20.795 11.0048L25.295 15.5048C25.5683 15.7782 25.5683 16.2214 25.295 16.4948L20.795 20.9948C20.5216 21.2681 20.0784 21.2681 19.805 20.9948C19.5316 20.7214 19.5316 20.2782 19.805 20.0048L23.81 15.9998L19.805 11.9948Z",
    fill: "#242336"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 7,
    y: 15.5,
    width: 0.9375,
    height: 1,
    fill: "#F84F39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1989 11.0048C12.4722 11.2782 12.4722 11.7214 12.1989 11.9948L8.19386 15.9998L12.1989 20.0048C12.4722 20.2782 12.4722 20.7214 12.1989 20.9948C11.9255 21.2681 11.4823 21.2681 11.2089 20.9948L6.70893 16.4948C6.43556 16.2214 6.43556 15.7782 6.70893 15.5048L11.2089 11.0048C11.4823 10.7315 11.9255 10.7315 12.1989 11.0048Z",
    fill: "#242336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandleBar);
export default __webpack_public_path__ + "static/media/handle_bar.001ac0e43f42bcf019b006f2add2d3d0.svg";
export { ForwardRef as ReactComponent };